<!-- 活动收益 [[ -->
<template>
    <div class="profit-con order-profit">
        <ul class="profit-con-tab">
            <!-- <li
                class="profit-con-label"
                v-bind:class="{'color-theme-active':tab.detail}"
                @click="detailClick()"
            >收益详情</li> -->
            <li
                class="profit-con-label"
                :class="{'color-theme-active':tab.item}"
                @click="itemClick()"
            >收益明细</li>
            <li
                class="profit-con-label"
                v-bind:class="{'color-theme-active':tab.arrival}"
                @click="arrivalClick()"
            >已到账明细</li>
        </ul>

        <!-- 收益明细 [[ -->
        <div class="profit-tab-con reward-detail" v-bind:class="{'f-hide':!tab.item}">
            <div class="profit-chart-top">
                <p class="profit-time-name f-inlineblock-top">收益时间</p>
                <div class="profit-time-con f-inlineblock-middle">
                    <el-date-picker
                        v-model="itemParam.dateVal"
                        type="daterange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        :start-placeholder="defaultsDate"
                        :end-placeholder="defaulteDate"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </div>
            </div>

            <div class="profit-day" style="margin-bottom: 30px;">
                <div class="profit-chart">
                    <div id="mountNode"></div>
                </div>
            </div>

            <div class="profit-list">
                <table class="profit-table">
                    <tr class="profit-table-head bg-gray">
                        <th class="profit-td-1">
                            <p class="profit-td-con">日期</p>
                        </th>
                        <th class="profit-td-2">
                            <p class="profit-td-con">活动</p>
                        </th>
                        <th class="profit-td-3 profit-td-border">
                            <p class="profit-td-con">收益金额</p>
                        </th>
                    </tr>
                    <template v-if="itemTableList.length>0">
                        <tr
                            class="profit-table-tr"
                            v-for="(item, index) in itemTableList"
                            :key="index"
                            v-bind:class="{'bg-gray':(index+1)%2==0}"
                            
                        >
                            <td class="profit-td-1 profit-td-border">
                                <p>{{item.dataTime}}</p>
                            </td>
                            <td class="profit-td-2 profit-td-border">
                                <p>{{item.title}}</p>
                            </td>
                            <td class="profit-td-3 profit-td-border">
                                <p>{{item.profit}}</p>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr class="profit-table-tr">
                            <td colspan="3" align="center">
                                <p class="profit-td-con">没数据</p>
                            </td>
                        </tr>
                    </template>
                </table>

                <!-- 分页 -->
                <pagination
                    :total="itemParam.count"
                    :page-size="itemParam.pageSize"
                    @change="itemPageChange"
                    v-if="itemParam.count>0"
                    ref="pager"
                ></pagination>
                <!-- 分页 -->
            </div>
        </div>
        <!-- 收益明细 ]] -->

        <!-- 到账明细 [[ -->
        <div class="profit-tab-con profit-detail" v-bind:class="{'f-hide':!tab.arrival}">
            <div class="profit-chart-top">
                <p class="profit-time-name f-inlineblock-top">到账日期</p>
                <div class="profit-time-con f-inlineblock-middle">
                    <el-date-picker
                        v-model="arrivalParam.dateVal"
                        type="daterange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        :start-placeholder="defaultsDate"
                        :end-placeholder="defaulteDate"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </div>
            </div>

            <div class="profit-list">
                <table class="profit-table">
                    <tr class="profit-table-head bg-gray">
                        <th class="profit-td-1">
                            <p class="profit-td-con">日期</p>
                        </th>
                        <th class="profit-td-2 profit-td-border">
                            <p class="profit-td-con">税后实收</p>
                        </th>
                        <th class="profit-td-3 profit-td-border">
                            <p class="profit-td-con">代缴税费</p>
                        </th>
                        <th class="profit-td-4">
                            <p class="profit-td-con">活动</p>
                        </th>
                    </tr>
                    <template v-if="arrivalTableList.length>0">
                        <tr
                            class="profit-table-tr"
                            v-for="(item, index) in arrivalTableList"
                            :key="index"
                            v-bind:class="{'bg-gray':(index+1)%2==0}"
                            v-if="arrivalTableList.length>0"
                        >
                            <td class="profit-td-1 profit-td-border">
                                <p class="profit-td-con">{{item.dataTime}}</p>
                            </td>
                            <td class="profit-td-2 profit-td-border">
                                <p class="profit-td-con">{{item.profit}}</p>
                            </td>
                            <td class="profit-td-3 profit-td-border">
                                <p class="profit-td-con">{{item.real_tax}}</p>
                            </td>
                            <td class="profit-td-3 profit-td-border">
                                <p class="profit-td-con" :title="item.title">{{item.title}}</p>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr class="profit-table-tr">
                            <td colspan="4" align="center">
                                <p class="profit-td-con">没数据</p>
                            </td>
                        </tr>
                    </template>
                </table>
                <!-- 分页 -->
                <pagination
                    :total="arrivalParam.count"
                    :page-size="arrivalParam.pageSize"
                    @change="arrivalPageChange"
                    v-if="arrivalParam.count>0"
                    ref="pager"
                ></pagination>
                <!-- 分页 -->
            </div>
        </div>
        <!-- 到账明细 ]] -->
    </div>
</template>
<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/profit/profit.scss";
</style>
<style scoped>
.el-date-table td.in-range div {
    background-color: #ffead7;
}
</style>
<!-- 活动收益 ]] -->
<script>
import pagination from "Components/v4/pagination/pagination_v4";
import switchButton from "Components/v4/button/switch_button";
import {
    missionAccountDetailList,
    missionIncomeDetailList,
    dailyMissionDetailList
} from "Services/getData.js";
import G2 from "@antv/g2";
export default {
    data() {
        return {
            dateFormat: "yyyy-MM-dd",
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //这里就是设置当天后的日期不能被点击
                }
            },
            tab: {
                detail: false,
                item: true,
                arrival: false
            },
            defaultsDate: "",
            defaulteDate: "",
            monthDefaultsDate: "",
            monthDefaulteDate: "",
            arrivalTableList: [],
            itemTableList: [],
            detailTableList: [],
            arrivalParam: {
                //到账明细搜索条件
                dateVal: [],
                beginTime: "",
                endTime: "",
                pageSize: 5,
                pageIndex: 0,
                count: 0
            },
            itemParam: {
                //收益明细搜索条件
                dateVal: [],
                beginTime: "",
                endTime: "",
                pageSize: 5,
                pageIndex: 0,
                type: 1,
                count: 0
            },
            detailParam: {
                //收益详情
                dateVal: [],
                beginTime: "",
                endTime: "",
                type: 1,
                pageSize: 5,
                pageIndex: 0,
                count: 0
            },
            showdata: [],
            chart: ""
        };
    },
    components: {
        pagination,
        switchButton
    },
    mounted() {
        this.getDefaulteDate();
        this.itemList();
        this.detailList();
    },
    watch: {
        "arrivalParam.dateVal": function(val) {
            this.arrivalList();
        },
        "itemParam.dateVal": function(val) {
            this.itemList();
            this.detailList();
        }
    },
    methods: {
        dateChange(val) {
            // console.log(this.dailyFlowParams.dateVal)
        },
        getDefaulteDate() {
            this.dateFormat = "yyyy-MM-dd";
            let startDate = Date.now() - 8.64e7 * 6;
            let endDate = Date.now();

            this.defaultsDate = this.$common.formatDate(startDate, "-");
            this.defaulteDate = this.$common.formatDate(endDate, "-");
            this.monthDefaultsDate = this.defaultsDate;
            this.monthDefaulteDate = this.defaulteDate;

            this.arrivalParam.dateVal[0] = this.$common.formatDate(
                startDate,
                "-"
            );
            this.arrivalParam.dateVal[1] = this.$common.formatDate(
                endDate,
                "-"
            );

            this.itemParam.dateVal[0] = this.$common.formatDate(startDate, "-");
            this.itemParam.dateVal[1] = this.$common.formatDate(endDate, "-");
        },
        arrivalPageChange(param) {
            this.arrivalParam.pageSize = param.pageSize; // 发送给接口的字段
            this.arrivalParam.pageIndex = param.pageIndex - 1; // 发送给接口的字段
            this.arrivalList();
        },
        itemPageChange(param) {
            this.itemParam.pageSize = param.pageSize; // 发送给接口的字段
            this.itemParam.pageIndex = param.pageIndex - 1; // 发送给接口的字段
            this.itemList();
        },
        itemClick() {
            this.tab.item = true;
            this.tab.detail = false;
            this.tab.arrival = false;
            this.itemList();
        },
        arrivalClick() {
            this.tab.arrival = true;
            this.tab.detail = false;
            this.tab.item = false;
            this.arrivalList();
        },
        async arrivalList() {
            //到账明细
            this.arrivalParam.beginTime = this.arrivalParam.dateVal[0];
            this.arrivalParam.endTime = this.arrivalParam.dateVal[1];
            let res = await missionAccountDetailList(this.arrivalParam);
            if (res.data.code == 0) {
                this.arrivalTableList = res.data.data.data;
                this.arrivalParam.pageSize = res.data.data.size;
                this.arrivalParam.count = res.data.data.count;
            } else {
            }
        },
        async itemList() {
            //收益明细
            this.itemParam.beginTime = this.itemParam.dateVal[0];
            this.itemParam.endTime = this.itemParam.dateVal[1];
            let res = await missionIncomeDetailList(this.itemParam);
            if (res.data.code == 0) {
                this.itemTableList = res.data.data.data;
                this.itemParam.pageSize = res.data.data.size;
                this.itemParam.count = res.data.data.count;
            } else {
            }
        },
        async detailList() {
            //收益详情dailyDetailList
            // this.detailParam.beginTime = this.detailParam.dateVal[0];
            // this.detailParam.endTime = this.detailParam.dateVal[1];

            // let res = await dailyMissionDetailList(this.detailParam);
            this.getChartData();
            // if (res.data.code == 0) {
            //     this.detailTableList = res.data.data.data;
            //     this.detailParam.pageSize = res.data.data.size;
            //     this.detailParam.count = res.data.data.count;
            // } else {
            // }
        },
        async getChartData() {
            //奖励详情绘图
            let params = {};
            params.type = this.itemParam.type;
            params.beginTime = this.itemParam.dateVal[0];
            params.endTime = this.itemParam.dateVal[1];
            let res = await dailyMissionDetailList(params);

            if (res.status === 200 && res.data.code === 0) {
                this.charShow(res.data.data);
            }
        },
        charShow(retData) {
            if (!this.chart) {
                this.chart = new G2.Chart({
                    container: "mountNode",
                    forceFit: true,
                    height: 300,
                    width: 600,
                    padding: [20, 50, 45, 50]
                });
            }
            retData.forEach((v, k) => {
                v.profit = Number(v.profit);
            });
            this.chart.source(retData);
            this.chart.scale("profit", {
                min: 0,
                alias: "收益"
            });
            this.chart.scale("dataTime", {
                // range: [0, 1]
            });
            this.chart.tooltip({
                crosshairs: {
                    type: "line"
                }
            });
            this.chart
                .line()
                .position("dataTime*profit")
                .color("#FD7E28");
            this.chart
                .point()
                .position("dataTime*profit")
                .size(4)
                .shape("circle")
                .style({
                    stroke: "#FD7E28",
                    fill: "#FD7E28",
                    lineWidth: 1
                });
            this.chart.render();
            G2.track(false);
        }
    }
};
</script>
